import { styled } from 'styled-components';

export const Title = styled.h5`
  color: var(--color-text-light);
  font-size: var(--font-sm);
  font-weight: var(--font-medium);
  padding: var(--spacing-medium) var(--spacing-big);
  text-align: center;
`;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-height: var(--preference-compose-modal-empty-height);
  text-align: center;
`;
